var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-container"},[_c('DayPilotCalendar',{ref:"calendar",attrs:{"config":_vm.calendarConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }